/**
 * @generated SignedSource<<cc5be788c5c8a71840b1db5873a4ad7c>>
 * @relayHash 2bb8d882fb273a48006a9f7e3bdd5876
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID app-buyer-misc/549.0.0-2026-03-06T17:27:41.838Z/HpSharedVideoComponentVideoQuery

import { ConcreteRequest } from 'relay-runtime';
export type HpSharedVideoComponentVideoQuery$variables = {
  videoId: string;
};
export type HpSharedVideoComponentVideoQuery$data = {
  readonly viewer: {
    readonly video: {
      readonly desktopFile: {
        readonly link: string | null;
      } | null;
      readonly mobileFile: {
        readonly link: string | null;
      } | null;
    } | null;
  };
};
export type HpSharedVideoComponentVideoQuery = {
  response: HpSharedVideoComponentVideoQuery$data;
  variables: HpSharedVideoComponentVideoQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "videoId"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "link",
    "storageKey": null
  }
],
v2 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "videoId",
      "variableName": "videoId"
    }
  ],
  "concreteType": "VideoVimeo",
  "kind": "LinkedField",
  "name": "video",
  "plural": false,
  "selections": [
    {
      "alias": "desktopFile",
      "args": [
        {
          "kind": "Literal",
          "name": "size",
          "value": "w960h540"
        }
      ],
      "concreteType": "VideoVimeoFile",
      "kind": "LinkedField",
      "name": "fileByVideoSize",
      "plural": false,
      "selections": (v1/*: any*/),
      "storageKey": "fileByVideoSize(size:\"w960h540\")"
    },
    {
      "alias": "mobileFile",
      "args": [
        {
          "kind": "Literal",
          "name": "size",
          "value": "w426h240"
        }
      ],
      "concreteType": "VideoVimeoFile",
      "kind": "LinkedField",
      "name": "fileByVideoSize",
      "plural": false,
      "selections": (v1/*: any*/),
      "storageKey": "fileByVideoSize(size:\"w426h240\")"
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "HpSharedVideoComponentVideoQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "HpSharedVideoComponentVideoQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "app-buyer-misc/549.0.0-2026-03-06T17:27:41.838Z/HpSharedVideoComponentVideoQuery",
    "metadata": {},
    "name": "HpSharedVideoComponentVideoQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "09111d18825c0fb8ee2edca3d4844176";

export default node;
